import api from '@/services/api'

export default {
  state: {
    isLoggedInEthosNps: !!localStorage.getItem('tokenEthosNps'),
    userEthosNps: {
      name: '',
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedInEthosNps = true
      state.userEthosNps = {
        name: user.name,
      }
    },

    LOGOUT(state) {
      state.isLoggedInEthosNps = false
      state.userEthosNps = {
        name: '',
      }
    },
  },

  actions: {
    async getMicrosoftLink({ commit }) {
      try {
        const response = await api.get('/auth/sign-in-microsoft/link')
        return response && response.data ? response.data : null
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async signInMicrosoft({ commit }, code) {
      try {
        const response = await api.post('/auth/sign-in-microsoft/code', code)

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          name: data && data.user ? data.user.name : '',
        }

        localStorage.setItem('tokenEthosNps', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedInEthosNps: (state) => state.isLoggedInEthosNps,
    user: (state) => state.userEthosNps,
  },
}
